import React, { useEffect } from "react";
/* Components */
import SignUpForm from "../components/form/signUp";
import { useNavigate } from "react-router-dom";
import { useMixPanel } from "../hooks/useMixPanel";
import { useTranslation } from "react-i18next";
import useUserStore from "../store/useUser.store";
import { MIX_PANEL_EVENTS } from "../utils/constans";
import ShaiaBot from "../components/shaiaBot/shaiabot";
import ToggleSwitch from "../components/form-elements/ToggleSwitch/toggleSwitch";
import SidebarIndex from "../components/sidebar/SidebarIndex";
/* Assets */
import logoShaia from "../assets/azul-alt.svg";

const Register = () => {
  const navigate = useNavigate();
  const { sendEvent } = useMixPanel();
  const { t, i18n } = useTranslation();
  const { setLang } = useUserStore();
  useEffect(() => {
    sendEvent(MIX_PANEL_EVENTS.registerView);
    localStorage.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSwitch = (event) => {
    i18n.changeLanguage(event ? "en" : "es");
    setLang(event ? "en" : "es");
    localStorage.setItem("lang", event ? "en" : "es");
  };

  return (
    <div className="relative flex h-screen w-full flex-row">
      <SidebarIndex />
      <div className="login-wrapper light-theme">
        <div className="md-max:mt-2 md-max:pb-4 md-max:justify-between flex w-full flex-row items-center justify-end pl-4 pr-9 md:absolute md:right-0 md:top-4">
          <img src={logoShaia} className="max-w-20 md:hidden" alt="Shaia" />
          <ToggleSwitch name="lang" onChange={onSwitch} />
        </div>
        <div className="sm-max:hidden">
          <ShaiaBot />
        </div>
        <SignUpForm />
        <p className="user-account-link !my-1">
          😎 {t("haveAccount")}.{" "}
          <button onClick={() => navigate("/login")}>{t("logIn")}</button>
        </p>
      </div>
    </div>
  );
};

export default Register;
